module.exports = __webpack_public_path__ + "static/media/phone3.b3afa58e.png";